// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__wo5tg","active":"downloadDropdown_active__1EBbm"};